module.exports = __webpack_public_path__ + "static/7-6d11b2498646dc1ba16477f9aa35e3ab.jpg";